import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({})
export class Colour extends Mappable {
  id!: string
  title!: string

  static create<Data>(attrs: Data) {
    return new Colour().map(attrs)
  }
}
